(function() {
  var allowedPages = [
    '/pages/shop-all-watches',
    '/products/paddock-74-ignition-orange',
    '/products/cypher-paddock-74-ignition-orange-orange-strap',
    '/products/paddock-74-le-mans-blue',
    '/products/cypher-paddock-74-le-mans-blue-black-strap',
    '/products/paddock-74-silverstone-green',
    '/products/cypher-paddock-74-silverstone-green-black-strap',
    '/products/paddock-74-grand-prix-panda',
    '/products/cypher-paddock-74-grand-prix-panda-orange-strap',
  ];

  var currentPath = window.location.pathname;
  var isAllowed = false;
  for (var i = 0; i < allowedPages.length; i++) {
    if (currentPath.indexOf(allowedPages[i]) > -1) { isAllowed = true; break; }
  }
  if (!isAllowed) return;

  function init() {
    if (document.getElementById('cyp-share-fab')) return;
    if (!document.body) { setTimeout(init, 100); return; }

    var isProductPage = currentPath.indexOf('/products') > -1;
    var bottomOffset = isProductPage ? '168px' : '92px';

    // Styles
    var style = document.createElement('style');
    style.textContent = [
      '#cyp-share-fab,#cyp-share-fab *{box-sizing:border-box;margin:0;padding:0;font-family:"Montserrat",sans-serif;-webkit-font-smoothing:antialiased}',
      '#cyp-share-fab{position:fixed;bottom:'+bottomOffset+';right:24px;z-index:2147483646;width:44px;height:44px;border-radius:50%;background:#fff;border:1.5px solid #E0E0DE;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 12px rgba(0,0,0,0.08);cursor:pointer;transition:all 0.2s ease;-webkit-tap-highlight-color:transparent;touch-action:manipulation}',
      '#cyp-share-fab:hover{border-color:#D95F00;box-shadow:0 4px 16px rgba(217,95,0,0.15);transform:scale(1.05)}',
      '#cyp-share-fab svg{width:18px;height:18px;stroke:#555;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:stroke 0.2s ease}',
      '#cyp-share-fab:hover svg{stroke:#D95F00}',
      '#cyp-share-toast{position:fixed;bottom:'+bottomOffset+';right:80px;z-index:2147483646;background:#0A0A0A;color:#fff;font-family:"Montserrat",sans-serif;font-size:11px;font-weight:500;letter-spacing:0.5px;padding:10px 16px;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,0.2);opacity:0;transform:translateX(8px);transition:all 0.3s ease;pointer-events:none;white-space:nowrap}',
      '#cyp-share-toast.cyp-show{opacity:1;transform:translateX(0)}',
      '#cyp-share-toast::after{content:"";position:absolute;top:50%;right:-6px;transform:translateY(-50%);width:0;height:0;border-top:6px solid transparent;border-bottom:6px solid transparent;border-left:6px solid #0A0A0A}',
      '@media(max-width:480px){#cyp-share-fab{right:20px;width:42px;height:42px}#cyp-share-toast{right:72px;font-size:10px;padding:8px 14px}}'
    ].join('');
    document.head.appendChild(style);

    // Toast
    var toast = document.createElement('div');
    toast.id = 'cyp-share-toast';
    document.body.appendChild(toast);

    // FAB
    var fab = document.createElement('button');
    fab.id = 'cyp-share-fab';
    fab.setAttribute('aria-label', 'Share this page');
    fab.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
    document.body.appendChild(fab);

    function showToast(msg) {
      toast.textContent = msg;
      toast.classList.add('cyp-show');
      setTimeout(function() { toast.classList.remove('cyp-show'); }, 2200);
    }

    function getShareData() {
      var title = document.title || 'Cypher Watch Company';
      var url = window.location.href;
      var text = '';

      // Try to get product name from the page
      var h1 = document.querySelector('h1');
      if (h1) {
        text = h1.textContent.trim() + ' by Cypher Watch Company';
      } else {
        text = 'Check this out from Cypher Watch Company';
      }

      return { title: title, text: text, url: url };
    }

    fab.addEventListener('click', function() {
      var data = getShareData();

      // Use native share on supported devices (mostly mobile)
      if (navigator.share) {
        navigator.share(data).catch(function() {
          // User cancelled — do nothing
        });
        return;
      }

      // Desktop fallback — copy link
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(data.url).then(function() {
          showToast('Link copied');
        }).catch(function() {
          fallbackCopy(data.url);
        });
      } else {
        fallbackCopy(data.url);
      }
    });

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        document.execCommand('copy');
        showToast('Link copied');
      } catch (e) {
        showToast('Could not copy');
      }
      document.body.removeChild(ta);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();